















import { Component, Vue } from 'vue-property-decorator';
import WpHeader from './components/wp/WpHeader.vue';
import WpFooter from './components/wp/WpFooter.vue';
import { mapGetters, mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Auth', {
      user: 'user',
      activeRoleKey: 'activeRoleKey',
    }),
    ...mapGetters('Auth', {
      userRole: 'userRole',
    }),
    ...mapState({
      reload: 'reload',
      loading: 'loading',
      snackbar: 'snackbar',
    }),
  },
  components: {
    WpHeader,
    WpFooter,
  },
})
export default class ErrorLayout extends Vue {
  userRole!: string;
  loading!: boolean;
  activeRoleKey!: string;
}
